import * as React from "react";
import { css } from "@emotion/react";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { textColor } from "main/javascripts/styles/base/colorStyle";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";

export interface IProps extends React.AllHTMLAttributes<HTMLDivElement> {
  title?: string;
  children: React.ReactNode;
}

export const DetailItem: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { title, children, ...rest } = props;
  return (
    <div css={blockStyle} {...rest}>
      {title && <h3 css={titleStyle}>{title}</h3>}
      {children}
    </div>
  );
};

const blockStyle = css`
  padding: ${space.atom2x} 0;
  color: ${textColor.secondaryDarkColor};
`;
const titleStyle = css`
  font-size: ${fontSize.subHeading};
  line-height: ${lineHeight.subHeadline2};
  padding: ${space.atom};
`;
